<template>
  <div class="instructors-dactive">
    <div class="mb-5 bg-white" v-if="items.length">
      <b-table stacked="lg" :fields="fieldsItems" :items="items" class="text-center">
        <template v-slot:cell(fullname)="row" >
          <router-link :to="'/user/'+row.item.User">{{row.item.fullname}}</router-link>
        </template>
        <template v-slot:cell(isActive)="row" >
          <!-- <toggle-button :width="70" v-model="row.item.isActive" :labels="{checked: 'فعال', unchecked: 'غیر فعال'}" @change="activete(row.item,row.index)" /> -->
          <div class="input-checkbox rtl text-right">
            <div class="md-checkbox">
              <input
                type="checkbox"
                :id="row.index"
                v-model="row.item.isActive"
                @change="activete(row.item, row.index)"
              >
              <label :for="row.index" class="font-14">فعال کنید</label>
            </div>
          </div>
        </template>
        <template v-slot:cell(action)="row" >
          <div class="text-center d-flex justify-content-between">
            <button
              @click="playMovie(row)"
              class="mt-1 bttn-material-circle bttn-md bttn-royal flaticon-play-1"
              v-ripple
              :title="'نمایش ویدئوآموزشی'"
            ></button>
            <!-- <button @click="remove(row.item, row.index)" class="font-16 px-5 py-2 bttn-fill bttn bttn-danger" v-ripple>حذف</button> -->
            <button
              @click="submitAction(row)"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
            >موارد بیشتر</button>
          </div>
        </template>
        <template v-slot:cell(row-details)="row">
          <div class="wrapper-form py-4">
            <form class="px-2 row" @submit.prevent>
              <div class="col-6">
                <div class="group-form">
                  <textarea
                    type="text"
                    v-model="row.item.description"
                    :class="{active:row.item.description != ''}"
                  ></textarea>
                  <span class="bar"></span>
                  <label for>توضیحات</label>
                </div>
              </div>
              <div class="col-12">
                <div class="text-left">
                  <button
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="submitAction(row)"
                  >کمتر</button>
                  <!-- <button class="font-16 px-5 py-2 bttn-fill bttn bttn-danger" v-ripple @click="submitAction(row)">انصراف</button> -->
                </div>
              </div>
            </form>
          </div>
        </template>
      </b-table>
      <page-number :lengthList="lengthListInstructorDeActive" @callBack="pageCallBack"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'instructors-dactive',
  props: ['items'],
  data() {
    return {
      fieldsItems: [
        { key: "fullname", label: "نام و نام خانوادگی" },
        { key: "category", label: "دسته فعالیت" },
        { key: "isActive", label: "وضعیت درخواست" },
        { key: "action", label: "عملیات" }
      ],
    }
  },
  computed: {
    lengthListInstructorDeActive() {
      return this.$store.state.dashboardAllCourses.lengthListInstructorDeActive
    }
  },
  methods: {
    pageCallBack(page) {
      this.$emit('pageCallBack', { page })
    },
    submitAction(row) {
      row.toggleDetails();
      //   this.$store.commit('dashboardAllCourses/SET_DATA_BOOLEAN', { id: 'instructors', index: row.index, key: 'isEdit', value: !row.item.isEdit })
    },
    async activete(item, index) {
      this.$store.dispatch('dashboardAllCourses/activeteInstructor', { active: item.isActive, id: item.User, index })

    },
    playMovie(row) {
      this.playVideo(row.item.test_video);
    },
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard-component/courses/instructors-dactive.vue